const en = {
    general: {
        app_name: "Tasks",
        overview: "Overview",
        settings: "Settings",
        archive: "Archive",
        dark_mode: "Dark mode",
        close: "Close"
    },
    overview: {
        header: "Your tasks",
        looksempty: "It looks empty here. Time to create a new task."
    },
    register: {
        email: "Email",
        password: "Password",
        repeat_password: "Repeat password",
        register: "Register",
        or_want_to_login: "or want to login?"
    },
    activate: {
        notification: {
            user_activated: "The user is now activated."
        }
    },
    login: {
        login: "Login",
        email: "Email",
        password: "Password",
        register_now: "Register now",
        forgot_password: "Forgot password?"
    },
    forgot_password: {
        header: "Forgot password?",
        header_description: "Enter below your email of your account. We will send then you a link, where you can reset your password.",
        email: "Email",
        request_password: "Request password",
        or_want_to_login: "Sign in?"
    },
    reset_password: {
        notification: {
            new_password_has_been_set: "The new password has been set.",
            passwords_do_not_match: "The passwords do not match with each other."
        },
        header: "Reset password",
        header_description: "You can set here now a new password for your account. This password will then be valid.",
        new_password: "New password",
        repeat_new_password: "Repeat new password",
        reset: "Reset"
    },
    archive: {
        header: "Archive"
    },
    detailtask: {
        notification: {
            marked_as_done: "The task has now been marked as done.",
            marked_as_done_on: "The task has been done on {date} {time}.",
            task_deleted: "The task has been deleted.",
            history_item_deleted: "The entry has been deleted.",
            the_task_has_been_archived: "The task has been archived."
        },
        back: "Back",
        edit: "Edit",
        interval: "Interval",
        next_execution: "Next execution",
        history: "History",
        progress: "Progress",
        archive_task: "Archive task",
        unarchive_task: "Unarchive task",
        delete_task: "Delete task",
        load_more: "Load more",
        now: "now",
        on_specific_time: "on specific time",
        mark_as_done: "Mark as done",
        next: "next",
        set: "set",
        time_until_next_execution: "Time until next execution",
        time_since_last_execution: "Time since last execution",
        days: "day(s)",
        hours: "hour(s)",
        minutes: "minute(s)",
        seconds: "second(s)",
        do_you_really_want_to_delete: "Do you really want to delete this task?",
        no_history_available: "No history available",
        task_never_run: "This task never run. Mark it as done, to see here the time until you have to do it again.",
        do_you_want_to_delete_history_item: "Do you really want to delete this history item?"
    },
    edittask: {
        notification: {
            task_updated: "The task has been updated."
        },
        header: "Edit task",
        name: "Name",
        description: "Description",
        interval: "Interval",
        save: "Save",
        cancel: "Cancel"
    },
    addtask: {
        notification: {
            task_added: "The task has been added."
        },
        header: "Add task",
        name: "Name",
        description: "Description",
        interval: "Interval",
        add: "Add",
        cancel: "Cancel"
    },
    taskcard: {
        next_execution: "Next execution"
    },
    sessioncard: {
        delete: "Delete",
        device_name: "Device name",
        device_os: "Device OS",
        started: "Started"
    },
    settings: {
        header: "Settings",
        language: "Language",
        change_password: "Change password",
        current_password: "Current password",
        new_password: "New password",
        repeat_new_password: "Repeat new password",
        change: "change",
        profile: "Profile",
        sign_out: "Sign out",
        notifications: "Notifications",
        turn_on_notifications: "Turn on notifications",
        send_test_notification: "Send test notification",
        test_notification_description: "Test here if the notifications are working.",
        devices: "Devices",
        devices_description: "You find here all devices where you are signed in."
    },
    interval: {
        every_minute: "Every minute", 
        every_five_minutes: "Every five minutes",
        every_ten_minutes: "Every ten minutes",
        every_fifteen_minutes: "Every fifteen minutes",
        every_half_hour: "Every half hour",
        every_hour: "Every hour",
        every_second_hour: "Every second hour",
        every_third_hour: "Every third hour",
        every_fourth_hour: "Every fourth hour",
        every_fifth_hour: "Every fifth hour",
        every_sixth_hour: "Every sixth hour",
        every_day: "Every day",
        every_second_day: "Every second day",
        every_third_day: "Every third day",
        every_fourth_day: "Every fourth day",
        every_fifth_day: "Every fifth day",
        every_sixth_day: "Every sixth day",
        every_week: "Every week",
        every_second_week: "Every second week",
        every_third_week: "Every third week",
        every_fourth_week: "Every fourth week",
        every_fifth_week: "Every fifth week",
        every_month: "Every month",
        every_second_month: "Every second month",
        every_third_month: "Every third month",
        every_fourth_month: "Every fourth month",
        every_fifth_month: "Every fifth month",
        every_half_year: "Every half year",
        every_year: "Every year",
        every_second_year: "Every second year"
    }
};

export default en;